// Code generated by Slice Machine. DO NOT EDIT.

import { defineAsyncComponent } from "vue";
import { defineSliceZoneComponents } from "@prismicio/vue";

export const components = defineSliceZoneComponents({
  airco_packages_grid: defineAsyncComponent(
    () => import("./AircoPackagesGrid/index.vue"),
  ),
  branch_grid: defineAsyncComponent(() => import("./BranchGrid/index.vue")),
  branch_slider: defineAsyncComponent(() => import("./BranchSlider/index.vue")),
  brand_logos_grid: defineAsyncComponent(
    () => import("./BrandLogosGrid/index.vue"),
  ),
  faq: defineAsyncComponent(() => import("./Faq/index.vue")),
  feature_cards_grid: defineAsyncComponent(
    () => import("./FeatureCardsGrid/index.vue"),
  ),
  feature_highlights: defineAsyncComponent(
    () => import("./FeatureHighlights/index.vue"),
  ),
  full_width_hero: defineAsyncComponent(
    () => import("./FullWidthHero/index.vue"),
  ),
  hero: defineAsyncComponent(() => import("./Hero/index.vue")),
  hero_background_content: defineAsyncComponent(
    () => import("./PageHero/index.vue"),
  ),
  image: defineAsyncComponent(() => import("./Image/index.vue")),
  image_cards: defineAsyncComponent(() => import("./ImageCards/index.vue")),
  image_text_overlap: defineAsyncComponent(
    () => import("./ImageTextOverlap/index.vue"),
  ),
  intro_text_with_ctas: defineAsyncComponent(
    () => import("./IntroTextWithCtas/index.vue"),
  ),
  key_options_grid: defineAsyncComponent(
    () => import("./KeyOptionsGrid/index.vue"),
  ),
  offerta_hero_form: defineAsyncComponent(
    () => import("./OffertaHeroForm/index.vue"),
  ),
  open_solicitation_cta: defineAsyncComponent(
    () => import("./OpenSolicitationCta/index.vue"),
  ),
  quote: defineAsyncComponent(() => import("./Quote/index.vue")),
  quote_cta: defineAsyncComponent(() => import("./QuoteCta/index.vue")),
  service_grid: defineAsyncComponent(() => import("./ServiceGrid/index.vue")),
  service_slider: defineAsyncComponent(
    () => import("./ServiceSlider/index.vue"),
  ),
  side_by_side_media_content: defineAsyncComponent(
    () => import("./SideBySideMediaContent/index.vue"),
  ),
  step_process: defineAsyncComponent(() => import("./StepProcess/index.vue")),
  text: defineAsyncComponent(() => import("./Text/index.vue")),
  text_image_horizontal: defineAsyncComponent(
    () => import("./TextImageHorizontal/index.vue"),
  ),
  text_with_image: defineAsyncComponent(
    () => import("./TextWithImage/index.vue"),
  ),
  trusted_by_features: defineAsyncComponent(
    () => import("./TrustedByFeatures/index.vue"),
  ),
  vacancy_grid: defineAsyncComponent(() => import("./VacancyGrid/index.vue")),
});
